import { setToken } from "../../setup/api";

export default {
  login(context, { email, password }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/signin", { email, password })
        .then(function(response) {
          setToken(response.data.token);
          context.commit("setLogged", true);
          resolve();
        })
        .catch(reject);
    });
  },

  register(context, { name, phone, email, password }) {
    const data = {
      name,
      phone,
      email,
      password
    };

    return new Promise((resolve, reject) => {
      window.axios
        .post("/users/add", data)
        .then(function(response) {
          setToken(response.data.token);
          context.commit("setLogged", true);
          context.dispatch("postLogin", null, { root: true });
          resolve();
        })
        .catch(reject);
    });
  },

  forgot(context, { email }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/forgot", { email })
        .then(resolve)
        .catch(reject);
    });
  },

  resetPassword(context, { password, token }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/reset-password", { password, token })
        .then(resolve)
        .catch(reject);
    });
  },

  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts/")
        .then(function(response) {
          context.commit("setUser", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  update(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/", data)
        .then(function() {
          context.commit("updateUser", data);
          resolve();
        })
        .catch(reject);
    });
  },

  updatePassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/change-password", data)
        .then(resolve)
        .catch(reject);
    });
  }
};
